/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SmyXAddress.vue?vue&type=template&id=ff3fa88e&scoped=true&lang=html&"
import script from "./SmyXAddress.vue?vue&type=script&lang=js&"
export * from "./SmyXAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3fa88e",
  null
  
)

export default component.exports